import React, {useCallback, useEffect, useState} from 'react';
import useEmblaCarousel from "embla-carousel-react";
import classNames from "classnames";
import Link from "@/Layouts/Link";
import Svg from "@/Components/Svg";
import Picture from "@/Components/Picture";
import '@/Scss/Site/Main/categories.scss';

const CategoriesCarousel = (props) => {
    const {categoriesData = {}} = props;
    const {title = '', link = '', linkName = '', categories = []} = categoriesData;
    const [scrollSnaps, setScrollSnaps] = useState([]);
    const [selectedSnap, setSelectedSnap] = useState(0);

    const [carouselRef, emblaApi] = useEmblaCarousel(
        {loop: categories.length > 1, align: 'start'}
    );

    const scrollTo = useCallback((index) => {
        emblaApi?.scrollTo(index);
    }, [emblaApi]);

    useEffect(() => {
        if (!emblaApi) return;

        const onReInit = (api) => {
            setScrollSnaps(api.scrollSnapList());
            setSelectedSnap(api.selectedScrollSnap());
        };

        const onSelect = (api) => {
            setSelectedSnap(api.selectedScrollSnap());
        };

        onReInit(emblaApi);

        emblaApi.on('reInit', onReInit);
        emblaApi.on('select', onSelect);

        return () => {
            emblaApi.off('reInit', onReInit);
            emblaApi.off('select', onSelect);
        };
    }, [emblaApi]);

    const goToPrev = useCallback(() => {
        emblaApi?.scrollPrev();
    }, [emblaApi]);

    const goToNext = useCallback(() => {
        emblaApi?.scrollNext();
    }, [emblaApi]);

    if (categories.length === 0) return null;

    return (
        <div className={`container`}>
            <div className={`categories`}>
                <div className={`categories__head`}>
                    <p className={`categories__title`}>{title}</p>
                    <Link href={link} className={`categories__link`}>{linkName}</Link>
                </div>
                <div className={`categories__body embla`}>
                    <div ref={carouselRef} className={`embla__viewport`}>
                        <div className={`embla__container`}>
                            {categories.map((el, i) => {
                                return <Link key={el.id} href={`${el.link}`} className={`embla__slide`}>
                                    <div className={`embla__slideNameContainer`}>
                                        <div className={`embla__slideLine`}></div>
                                        <p className={`embla__slideName`}>{el.name}</p>
                                    </div>
                                    <Picture
                                        src={el.imgPath}
                                        alt={el.alt}
                                        title={el.title}
                                        imageClassName={`increase`}
                                    />
                                </Link>
                            })}
                        </div>
                    </div>
                    {categories.length > 1 && (
                        <div className={`embla__controls`}>
                            <div className={`embla__dots`}>
                                {scrollSnaps.map((_, index) => (
                                    <div
                                        key={`dot-${index}`}
                                        className={classNames('embla__dot', {
                                            'embla__dot--selected': index === selectedSnap,
                                        })}
                                        onClick={() => scrollTo(index)}
                                    >
                                    </div>
                                ))}
                            </div>
                            <div className={`embla__buttons`}>
                                <div className={`embla__prev`} onClick={goToPrev}>
                                    <Svg id={`arrowLeft`} className={`svg--arrow`} />
                                </div>
                                <div className={`embla__next`} onClick={goToNext}>
                                    <Svg id={`arrowRight`} className={`svg--arrow`} />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default CategoriesCarousel;
